import styled from 'styled-components'

export const StyledImage = styled.img`
    width: 100%;
    height: auto;   
    border-radius: 5px;
    border: 3px solid #709FB0;
    &:hover {
        opacity: 0.9;
    }
`

export const ImageBox = styled.div`
    width: 300px;
    margin: 2rem;
`